import _ from 'lodash';

export default function getCollectedPets(pets) {
	return _.filter(pets, 'isCollected');
}



// WEBPACK FOOTER //
// ./src/selectors/getCollectedPets.js